import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HALResponse } from 'ng/src/app/shared/model/app.model';
import { map } from 'rxjs/operators';
import { SystemParameter, SystemParameterViewModel } from './system-parameters.model';
import { GeneralParameters } from "app/shared/model/request-parameter.model";

@Injectable({
	providedIn: 'root'
})
export class SystemParametersService {
	constructor(private http: HttpClient) { }

	getSystemParametersViewModel() {
		return this.http.get<HALResponse<{ systemParameters: SystemParameter[] }>>(
			'/api/systemParameters?size=10000'
		)
		.pipe(
			map(r => {
				const vm: SystemParameterViewModel[] = [];

				r._embedded.systemParameters.forEach(param => {
					if (!param.name.endsWith('.auto-value'))
						vm.push(new SystemParameterViewModel(param));
				});

				return vm;
			})
		);
	}
	
	getNameLike(nameLike: string | string[]) {
		return this.http.get<HALResponse<{ systemParameters: SystemParameter[] }>>('/api/systemParameters', {
			params: {
				nameLike: nameLike,
				size: 10000
			} as GeneralParameters
		})
	}

	createSystemParameter(name: string, value: string) {
		return this.http.post<SystemParameter>('/api/systemParameters', {
			name: name,
			value: value
		});
	}

	updateSystemParameter(systemParameterLink: string, value: string) {
		return this.http.patch<SystemParameter>(systemParameterLink, {
			value: value
		});
	}

	deleteSystemParameter(systemParameterLink: string) {
		return this.http.delete<void>(systemParameterLink);
	}
}